/**
 * Created by tomere on 08/05/2017.
 */
export const RELEASE_BUNDLE_CONSTANTS = {
    defaultPackageName: 'Files'
}



// WEBPACK FOOTER //
// ./modules/distribution/constants/releaseBundle.constants.js